import client from './client';

export const listRefunds = () => client.get('/refunds').then((r) => r.data);
export const createRefunds = (rows) => client.post('/refunds', { rows }).then((r) => r.data);
export const approveRefund = (id, note) => client.post(`/refunds/${id}/approve`, { note }).then((r) => r.data);
export const rejectRefund = (id, reason) => client.post(`/refunds/${id}/reject`, { reason }).then((r) => r.data);
export const deleteRefund = (id) => client.delete(`/refunds/${id}`).then((r) => r.data);
export const applyRefunds = (confirmed) => client.post('/refunds/apply', { confirmed }).then((r) => r.data);
export const reassignRefund = (id, orderCode, wholeMonth) => client.post(`/refunds/${id}/reassign`, { orderCode, wholeMonth }).then((r) => r.data);
